import Link from 'next/link';
import { Dispatch, FC, SetStateAction } from 'react';
import { ChevronRight, Close } from '@eqi-investimentos/icons/web';
import { Box, Flex, Text } from '@eqi-investimentos/react';
import { Button } from '@chakra-ui/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { IconButton } from '@/components/elements/IconButton';
import { CardAssetRecomendationData } from '.';

export const BackFace: FC<BackFaceProps> = ({
  data,
  handleInvestIn,
  setIsShowingFront,
}) => {
  const t = useT();
  const assetName =
    data.name.length > 8 ? `${data.name.slice(0, 8)}...` : data.name;

  return (
    <Box
      pos="relative"
      w="13.25rem"
      h="9.375rem"
      p="0.5rem"
      gap="12"
      borderRadius="xs"
      bgColor="content.alwaysDark"
      onMouseLeave={() => setIsShowingFront(() => true)}
    >
      <Flex
        pos="relative"
        justifyContent="flex-end"
        px="2.5"
        pt="2.5"
        pb="1rem"
      >
        <IconButton
          icon={Close}
          ariaLabel="Inverter"
          onButtonClick={() => setIsShowingFront(() => true)}
          iconProps={{
            w: 20,
            h: 20,
            transform: 'rotate(90deg)',
            color: 'content.alwaysLight',
          }}
        />
      </Flex>
      <Flex flexDir="column" px="4" gap="m">
        <Button
          onClick={() => handleInvestIn(data)}
          variant="ghost"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p="0"
          w="full"
          h="1.25rem"
          color="action.active.brandLight"
          transition="0.5s all ease-in"
          _hover={{ color: 'content.brand' }}
          sx={{
            svg: {
              w: `16px !important`,
              h: `16px !important`,
            },
            _hover: {
              svg: {
                color: 'action.active.brandLight',
              },
              p: {
                color: 'action.active.brandLight',
              },
            },
          }}
        >
          <Option
            content={`${t('screens.recommendations.cardRecommendation.investIn')} ${assetName}`}
          />
        </Button>
        <Flex
          as={Link}
          href={PATHS.investments.index + `?busca=${data?.ticker}`}
          alignItems="center"
          p="0"
          w="full"
          h="1.25rem"
          color="action.active.brandLight"
          transition="0.5s all ease-in"
          _hover={{ color: 'content.brand' }}
          sx={{
            _hover: {
              svg: {
                color: 'action.active.brandLight',
              },
              p: {
                color: 'action.active.brandLight',
              },
            },
          }}
        >
          <Option
            content={t(
              'screens.recommendations.cardRecommendation.seeRecommendations'
            )}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

const Option = ({ content }: { content: string }) => (
  <Flex w="full" h="1.375rem" alignItems="center" gap="4" color="inherit">
    <Text
      size="m"
      fontWeight="semibold"
      color="content.inverse"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
    >
      {content}
    </Text>
    <ChevronRight w="16" h="16" color="inherit" />
  </Flex>
);

type BackFaceProps = {
  data: CardAssetRecomendationData;
  handleInvestIn: (data: CardAssetRecomendationData) => void;
  setIsShowingFront: Dispatch<SetStateAction<boolean>>;
};
